import { useIntl } from 'react-intl';
import { Warehouse } from '../modules/stock/models/StockLine';

interface Props {
  value?: Warehouse | null;
  onChange?: (value: Warehouse | null) => void;
  disabled?: boolean;
}
export default function WarehouseFilter({
  value = null,
  onChange = () => {},
  disabled = false,
}: Props) {
  const intl = useIntl();

  return (
    <div className="form-group d-inline-block w-250px">
      <label htmlFor="warehouse" className="form-label">
        {intl.formatMessage({ id: 'stock.warehouse' })}
      </label>
      <select
        id="warehouse"
        className="form-select"
        value={value ?? -1}
        disabled={disabled}
        onChange={(e) =>
          onChange(
            (+e.target.value > -1 ? +e.target.value : null) as Warehouse | null
          )
        }
      >
        <option value={-1}>{intl.formatMessage({ id: 'stock.all' })}</option>
        <option value={Warehouse.FACTORY}>
          {intl.formatMessage({ id: 'stock.factory' })}
        </option>
        <option value={Warehouse.INTERFRISA_GETAFE}>
          {intl.formatMessage({ id: 'stock.getafe' })}
        </option>
        <option value={Warehouse.FOODFORJOE_MASSANES}>
          {intl.formatMessage({ id: 'stock.massanes' })}
        </option>
      </select>
    </div>
  );
}
